// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AccordionFilter_Wrapper__JY7cP","Title":"AccordionFilter_Title__44_ds","Content":"AccordionFilter_Content__2xFYe","Open":"AccordionFilter_Open__os_j5"};